import styles from '@/styles/chat.module.scss';

/**
 * BotMessage — пузырь сообщения от бота.
 * Принимает text с \n и отображает переносы строк.
 */
export default function BotMessage({ text, children }) {
  return (
    <div className={styles.msg}>
      {text && (
        <div
          className={styles.bubble}
          dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }}
        />
      )}
      {children}
    </div>
  );
}
